import GetLoading from "../../share/getLoading";
import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Checkbox,
  TimePicker,
  Button,
  message,
  Select,
  DatePicker,
} from "antd";
import dayjs from "dayjs";
import { request } from "../../share/request";
import { getCurrentUser } from "../../share/getProfile";
import "../../styles/Home-module.css";
import { useReactToPrint } from "react-to-print";
import { BsPrinterFill, BsSaveFill } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { BiSave } from "react-icons/bi";

const { Option } = Select;

export default function FormPantient({
  closeModel,
  update_form,
  updateid,
  cleardata,
  onSaveSuccess,
  shouldPrint,
  onPrintComplete,
}) {
  const getProfileOrg = getCurrentUser();
  const [loading, setLoading] = useState(false);

  const [DateSelect, setDateSelect] = useState();
  const day = dayjs(DateSelect).format("DD");
  const month = dayjs(DateSelect).format("MM");
  const year = dayjs(DateSelect).format("YYYY");

  const initialForm = {
    date_pantient: "",
    date: day,
    month: month,
    year: year,
    place: "",
    sentTo: "",
    name: "",
    gender: "",
    age: "",
    phone: "",
    times: Array(6).fill(null),
    accident: {
      car: false,
      moto: false,
      walk: false,
      police: false,
      people: false,
      doctor: false,
      other: "",
    },
    injury: {
      head: {
        wound: false,
        bleeding: false,
        fracture: false,
        confused: false,
        unconscious: false,
      },
      neck: {
        wound: false,
        bleeding: false,
        fracture: false,
        pupilDilated: false,
        pupilConstricted: false,
      },
      face: { wound: false, bleeding: false, fracture: false },
      chest: {
        wound: false,
        bleeding: false,
        fracture: false,
        explosion: false,
      },
      abdomen: { wound: false, bleeding: false, fracture: false, stab: false },
      back: { wound: false, bleeding: false, fracture: false, poison: false },
      upperLimb: {
        wound: false,
        bleeding: false,
        fracture: false,
        snakeBite: false,
      },
      lowerLimb: {
        wound: false,
        bleeding: false,
        fracture: false,
        drowning: false,
      },
      pelvis: { wound: false, bleeding: false, fracture: false },
      genital: { wound: false, bleeding: false, fracture: false },
      skin: { wound: false, bleeding: false, fracture: false },
      other1: "",
      other2: "",
    },
    diagnosis: {
      noBreath: false,
      breath: false,
      suction: false,
      oxygen: false,
      raiseSway: false,
      raiseSuction: false,
      tube: false,
      washWound: false,
      pcr: false,
      immobilize: false,
      stopBleed: false,
      serum: false,
      diagnosis1: "",
      diagnosis2: "",
      diagnosis3: "",
      diagnosis4: "",
      diagnosis5: "",
      respiratoryRate: "",
      bloodPressure: "",
      pulseRate: "",
      oxygenLevel: "",
      glucoseLevel: "",
      additionalDescription: "",
    },
    org_code: getProfileOrg.org_code,
  };
  const [form, setForm] = useState({
    date_pantient: "",
    date: day,
    month: month,
    year: year,
    place: "",
    sentTo: "",
    name: "",
    gender: "",
    age: "",
    phone: "",
    times: Array(6).fill(null),
    accident: {
      car: false,
      moto: false,
      walk: false,
      police: false,
      people: false,
      doctor: false,
      other: "",
    },
    injury: {
      head: {
        wound: false,
        bleeding: false,
        fracture: false,
        confused: false,
        unconscious: false,
      },
      neck: {
        wound: false,
        bleeding: false,
        fracture: false,
        pupilDilated: false,
        pupilConstricted: false,
      },
      face: { wound: false, bleeding: false, fracture: false },
      chest: {
        wound: false,
        bleeding: false,
        fracture: false,
        explosion: false,
      },
      abdomen: { wound: false, bleeding: false, fracture: false, stab: false },
      back: { wound: false, bleeding: false, fracture: false, poison: false },
      upperLimb: {
        wound: false,
        bleeding: false,
        fracture: false,
        snakeBite: false,
      },
      lowerLimb: {
        wound: false,
        bleeding: false,
        fracture: false,
        drowning: false,
      },
      pelvis: { wound: false, bleeding: false, fracture: false },
      genital: { wound: false, bleeding: false, fracture: false },
      skin: { wound: false, bleeding: false, fracture: false },
      other1: "",
      other2: "",
    },
    diagnosis: {
      noBreath: false,
      breath: false,
      suction: false,
      oxygen: false,
      raiseSway: false,
      raiseSuction: false,
      tube: false,
      washWound: false,
      pcr: false,
      immobilize: false,
      stopBleed: false,
      serum: false,
      diagnosis1: "",
      diagnosis2: "",
      diagnosis3: "",
      diagnosis4: "",
      diagnosis5: "",
      respiratoryRate: "",
      bloodPressure: "",
      pulseRate: "",
      oxygenLevel: "",
      glucoseLevel: "",
      additionalDescription: "",
    },
    org_code: getProfileOrg.org_code,
  });
  useEffect(() => {
    console.log("day nunumber  : ", day);
    if (updateid) {
      setForm(update_form);
      console.log("list data update in form : ", update_form);
    }
    if (cleardata === 0) {
      setForm(initialForm);
    }
    console.log("orgcode  : ", getProfileOrg.org_code);
  }, [updateid, cleardata]);

  // Handlers
  const handleInput = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };
  const handleDate = (field) => (e) => {
    const formattedDate = e ? dayjs(e).format("YYYY-MM-DD") : null;
    setDateSelect(formattedDate);
    const updatedForm = { ...form, [field]: formattedDate };
    setForm(updatedForm);
  };
  const handleTime = (idx) => (time, timeString) => {
    const times = [...form.times];
    times[idx] = timeString;
    setForm({ ...form, times });
  };
  const handleAccident = (field) => (e) => {
    setForm({
      ...form,
      accident: { ...form.accident, [field]: e.target.checked },
    });
  };
  const handleAccidentOther = (e) => {
    setForm({
      ...form,
      accident: { ...form.accident, other: e.target.value },
    });
  };
  const handleInjuryCheckbox = (part, type) => (e) => {
    setForm({
      ...form,
      injury: {
        ...form.injury,
        [part]: {
          ...form.injury[part],
          [type]: e.target.checked,
        },
      },
    });
  };
  const handleInjuryOther = (field) => (e) => {
    setForm({
      ...form,
      injury: {
        ...form.injury,
        [field]: e.target.value,
      },
    });
  };
  const handleDiagnosisCheckbox = (type) => (e) => {
    setForm({
      ...form,
      diagnosis: {
        ...form.diagnosis,
        [type]: e.target.checked,
      },
    });
  };
  const handleDiagnosisInput = (field) => (e) => {
    setForm({
      ...form,
      diagnosis: {
        ...form.diagnosis,
        [field]: e.target.value,
      },
    });
  };
  const handleDiagnosisField = (field) => (e) => {
    setForm({
      ...form,
      diagnosis: {
        ...form.diagnosis,
        [field]: e.target.value,
      },
    });
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      // Prepare form data

      let formData = { ...form };

      if (handleDate) {
        formData = {
          ...form,
          date: dayjs(DateSelect).format("DD"),
          month: dayjs(DateSelect).format("MM"),
          year: dayjs(DateSelect).format("YYYY"),
        };
        console.log("new handle date change for : formData : ", formData);
      }

      // Send the form data to your backend API (adjust the URL accordingly)
      const methode = updateid === "" ? "post" : "put";
      const response = await request(
        `caractivityaccidentform`,
        methode,
        formData
      );
      // Check for successful response
      if (response) {
        message.success("Data saved successfully!");
        closeModel();
        setForm(initialForm);
        if (onSaveSuccess) onSaveSuccess(); // ✅ Trigger parent to refresh
      } else {
        message.error("Failed to save data. Please try again.");
      }

      console.log(form);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Patient Form",
  });
  return (
    <>
      <div ref={printRef}>
        <meta charSet="UTF-8" />
        <title>Patient Form</title>
        <style>{`
                                  @media print {
                                      .div_date_in_head{
                                      display: none !important;
                                  }

                                    .date_in_head{
                                  display: block !important;
                                    }
                                                                      
                                     .form-table {
                                    font-size : 11pt !important;
                                    
                                   
                                  }
                                    
                                 table, td, th {
                                  border: 1px dotted gray !important;
                                  border-collapse: collapse;
                                }
                                   .ant-btn {
                                      display: none;
                                    }
                              
                                    input,
                                    select,
                                    .ant-input,
                                    .ant-select-selector {
                                      font-size: 11pt !important;
                                      border: none !important;
                                      background: none !important;
                                      color: black !important;
                                      width: 100%;
                                    }

                               

                                    .header-cell {
                                      font-size: 12pt;
                                      font-weight: bold;
                                    }

                                    .section-header {
                                      font-size: 11pt;
                                    }

                                    html, body {
                                      margin: 0;
                                      padding: 0;
                                    }
                                  }

                                  @page {
                                    size: A4;
                                  margin:5mm 20mm 10mm 17mm;  
                             


                                  }
                                
          .date_in_head{
          display: none;
          }
              .form-table {
           font-family: 'Content', sans-serif;
          width: 909px;
          border-collapse: collapse;
          margin: 0 auto;
        }
        .form-table td {
          padding: 8px;
          border: 1px solid #000;
          vertical-align: top;
          position: relative;
        }
        .header-cell {
          text-align: center;
          font-size: 18px;
          padding: 20px 0;
        }
        .section-header {
          font-weight: bold;
          background-color: #f0f0f0;
        }
        .form-table .input-field {
          width: 100%;
          /* Remove border and background overrides to show default AntD border */
        }
          .form-table-tr-hereder{
          text-align: center;
          font-weight: bold;
          color: #1e8449;
          }
        .save-btn-row {
          text-align: center;
          padding: 20px 0;
        }
      
      `}</style>

        <table className="form-table">
          {/* Header Section */}
          <tbody>
            <tr>
              <td colSpan="6" className="header-cell">
                ព្រះរាជាណាចក្រកម្ពុជា
                <br />
                ជាតិ សាសនា ព្រះមហាក្សត្រ
              </td>
            </tr>

            {/* Hospital Information */}
            <tr>
              <td colSpan="3">
                {getProfileOrg.org_name_kh}
                <br />
                ផ្នែករថយន្តសង្គ្រោះ
              </td>
              <td colSpan="3" style={{ textAlign: "right" }}>
                <div className="date_in_head">
                  {" "}
                  ថ្ងៃទី {dayjs(form.date_pantient).format("DD")} ខែ{" "}
                  {dayjs(form.date_pantient).format("MM")} ឆ្នាំ{" "}
                  {dayjs(form.date_pantient).format("YYYY")}
                  {/* <Input
                    className="input-field"
                    style={{ width: 40 }}
                    value={form.date}
                    onChange={handleInput("date")}
                  />{" "}
                  ខែ{" "}
                  <Input
                    className="input-field"
                    style={{ width: 40 }}
                    value={form.month}
                    onChange={handleInput("month")}
                  />{" "}
                  ឆ្នាំ
                  <Input
                    className="input-field"
                    style={{ width: 60 }}
                    value={form.year}
                    onChange={handleInput("year")}
                  /> */}
                </div>

                <div className="div_date_in_head">
                  {"ថ្ងៃខែបញ្ជូនជំងឺ : "}
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    value={
                      form.date_pantient ? dayjs(form.date_pantient) : null
                    }
                    onChange={handleDate("date_pantient")}
                  />
                </div>
              </td>
            </tr>

            {/* Patient Information Section */}
            <tr className="section-header">
              <td colSpan="6">ព័ត៌មានអ្នកជម្ងឺ</td>
            </tr>

            {/* Patient Info Rows */}
            <tr>
              <td colSpan={3}>
                ទីកន្លែងកើតហេតុ :{" "}
                <Input
                  className="input-field"
                  value={form.place}
                  onChange={handleInput("place")}
                />
              </td>
              <td colSpan={3}>
                បញ្ជូនទៅ:{" "}
                <Input
                  className="input-field"
                  value={form.sentTo}
                  onChange={handleInput("sentTo")}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                ឈ្មោះ:{" "}
                <Input
                  className="input-field"
                  value={form.name}
                  onChange={handleInput("name")}
                />
              </td>
              <td>
                ភេទ:{" "}
                <Select
                  className="input-field"
                  value={form.gender}
                  onChange={(value) => setForm({ ...form, gender: value })}
                  style={{ width: "100%" }}
                >
                  <Option value="">ជ្រើសរើស</Option>
                  <Option value="Male">ប្រុស</Option>
                  <Option value="Female">ស្រី</Option>
                </Select>
              </td>
              <td colSpan={2}>
                អាយុ:{" "}
                <Input
                  className="input-field"
                  value={form.age}
                  onChange={handleInput("age")}
                />
              </td>
              <td>
                លេខទូរស័ព្ទ:{" "}
                <Input
                  className="input-field"
                  value={form.phone}
                  onChange={handleInput("phone")}
                />
              </td>
            </tr>

            {/* ម៉ោង Information Section */}
            <tr className="section-header">
              <td colSpan="6">ម៉ោង</td>
            </tr>

            {/* ម៉ោង Info Rows */}
            <tr className="form-table-tr-hereder">
              <td>ទទួលទូរស័ព្ទ</td>
              <td>ចេញដំណើរ</td>
              <td>ដល់គោលដៅ</td>
              <td>ដល់មន្ទីរពេទ្យ</td>
              <td>ចេញដំណើរ</td>
              <td>ដល់គោលដៅ</td>
            </tr>
            <tr>
              {[0, 1, 2, 3, 4, 5].map((idx) => (
                <td key={idx}>
                  <TimePicker
                    className="input-field"
                    format="HH:mm"
                    value={
                      form.times[idx] ? dayjs(form.times[idx], "HH:mm") : null
                    }
                    onChange={handleTime(idx)}
                  />
                </td>
              ))}
            </tr>

            {/* ប្រភេទគ្រោះថ្នាក់ Information Section */}
            <tr className="section-header">
              <td colSpan="6">ប្រភេទគ្រោះថ្នាក់</td>
            </tr>

            {/* ប្រភេទគ្រោះថ្នាក់ Info Rows */}
            <tr className="form-table-tr-hereder">
              <td colSpan={3}>គ្រោះថ្នាក់ចារាចរណ៍</td>
              <td colSpan={3}>អន្តរាគមន៍នៅកន្លែងកើតហេតុ</td>
            </tr>
            <tr>
              <td>
                <Checkbox
                  checked={form.accident.car}
                  onChange={handleAccident("car")}
                />{" "}
                រថយន្ត
              </td>
              <td>
                <Checkbox
                  checked={form.accident.moto}
                  onChange={handleAccident("moto")}
                />{" "}
                ម៉ូតូ
              </td>
              <td>
                <Checkbox
                  checked={form.accident.walk}
                  onChange={handleAccident("walk")}
                />{" "}
                ថ្មើរជើង
              </td>
              <td colSpan={3}>
                <Checkbox
                  checked={form.accident.police}
                  onChange={handleAccident("police")}
                />{" "}
                នគបាល{" "}
                <Checkbox
                  checked={form.accident.people}
                  onChange={handleAccident("people")}
                />{" "}
                ប្រជាជន{" "}
                <Checkbox
                  checked={form.accident.doctor}
                  onChange={handleAccident("doctor")}
                />{" "}
                ពេទ្យ <br />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>ផ្សេងៗ:</p>
                  <Input
                    className="input-field"
                    value={form.accident.other}
                    onChange={handleAccidentOther}
                  />
                </div>
              </td>
            </tr>

            {/* វិភាគរបួសស្នាម Information Section */}
            <tr className="section-header">
              <td colSpan="6">វិភាគរបួសស្នាម</td>
            </tr>
            {/* វិភាគរបួសស្នាម Info Rows */}
            <tr className="form-table-tr-hereder">
              <td>បរិយាយ</td>
              <td>របួស</td>
              <td>ហូរឈាម</td>
              <td>បាក់ឆ្អឹង</td>
              <td colSpan={2} style={{ textAlign: "center" }}>
                សភាពស្មារតី
              </td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>ក្បាល</td>
              <td>
                <Checkbox
                  checked={form.injury.head.wound}
                  onChange={handleInjuryCheckbox("head", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.head.bleeding}
                  onChange={handleInjuryCheckbox("head", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.head.fracture}
                  onChange={handleInjuryCheckbox("head", "fracture")}
                />
              </td>
              <td style={{ width: 200 }}>
                រវើរវាយ{" "}
                <Checkbox
                  checked={form.injury.head.confused}
                  onChange={handleInjuryCheckbox("head", "confused")}
                />
              </td>
              <td>
                ប្រកាច់{" "}
                <Checkbox
                  checked={form.injury.head.unconscious}
                  onChange={handleInjuryCheckbox("head", "unconscious")}
                />
              </td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>ក</td>
              <td>
                <Checkbox
                  checked={form.injury.neck.wound}
                  onChange={handleInjuryCheckbox("neck", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.neck.bleeding}
                  onChange={handleInjuryCheckbox("neck", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.neck.fracture}
                  onChange={handleInjuryCheckbox("neck", "fracture")}
                />
              </td>
              <td>
                កូនក្រមុំភ្នែករីកធំ{" "}
                <Checkbox
                  checked={form.injury.neck.pupilDilated}
                  onChange={handleInjuryCheckbox("neck", "pupilDilated")}
                />
              </td>
              <td>
                រួមតូច{" "}
                <Checkbox
                  checked={form.injury.neck.pupilConstricted}
                  onChange={handleInjuryCheckbox("neck", "pupilConstricted")}
                />
              </td>
            </tr>

            <tr style={{ textAlign: "center" }}>
              <td>មុខ</td>
              <td>
                <Checkbox
                  checked={form.injury.face.wound}
                  onChange={handleInjuryCheckbox("face", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.face.bleeding}
                  onChange={handleInjuryCheckbox("face", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.face.fracture}
                  onChange={handleInjuryCheckbox("face", "fracture")}
                />
              </td>
              <td colSpan={2} className="form-table-tr-hereder">
                មូលហេតុអ្នកជំងឺ
              </td>
            </tr>

            <tr style={{ textAlign: "center" }}>
              <td>ទ្រូង</td>
              <td>
                <Checkbox
                  checked={form.injury.chest.wound}
                  onChange={handleInjuryCheckbox("chest", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.chest.bleeding}
                  onChange={handleInjuryCheckbox("chest", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.chest.fracture}
                  onChange={handleInjuryCheckbox("chest", "fracture")}
                />
              </td>
              <td>
                អាវុធជាតិផ្ទុះ{" "}
                <Checkbox
                  checked={form.injury.chest.explosion}
                  onChange={handleInjuryCheckbox("chest", "explosion")}
                />
              </td>
              <td></td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>ពោះ</td>
              <td>
                <Checkbox
                  checked={form.injury.abdomen.wound}
                  onChange={handleInjuryCheckbox("abdomen", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.abdomen.bleeding}
                  onChange={handleInjuryCheckbox("abdomen", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.abdomen.fracture}
                  onChange={handleInjuryCheckbox("abdomen", "fracture")}
                />
              </td>
              <td>
                មុតស្រួច{" "}
                <Checkbox
                  checked={form.injury.abdomen.stab}
                  onChange={handleInjuryCheckbox("abdomen", "stab")}
                />
              </td>
              <td></td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>ខ្នង</td>
              <td>
                <Checkbox
                  checked={form.injury.back.wound}
                  onChange={handleInjuryCheckbox("back", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.back.bleeding}
                  onChange={handleInjuryCheckbox("back", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.back.fracture}
                  onChange={handleInjuryCheckbox("back", "fracture")}
                />
              </td>
              <td>
                ពុល{" "}
                <Checkbox
                  checked={form.injury.back.poison}
                  onChange={handleInjuryCheckbox("back", "poison")}
                />
              </td>
              <td></td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>អវៈយវៈលើ</td>
              <td>
                <Checkbox
                  checked={form.injury.upperLimb.wound}
                  onChange={handleInjuryCheckbox("upperLimb", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.upperLimb.bleeding}
                  onChange={handleInjuryCheckbox("upperLimb", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.upperLimb.fracture}
                  onChange={handleInjuryCheckbox("upperLimb", "fracture")}
                />
              </td>
              <td>
                ពស់ចឹក{" "}
                <Checkbox
                  checked={form.injury.upperLimb.snakeBite}
                  onChange={handleInjuryCheckbox("upperLimb", "snakeBite")}
                />
              </td>
              <td></td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>អវៈយវៈក្រោម</td>
              <td>
                <Checkbox
                  checked={form.injury.lowerLimb.wound}
                  onChange={handleInjuryCheckbox("lowerLimb", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.lowerLimb.bleeding}
                  onChange={handleInjuryCheckbox("lowerLimb", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.lowerLimb.fracture}
                  onChange={handleInjuryCheckbox("lowerLimb", "fracture")}
                />
              </td>
              <td>
                លង់ទឹក{" "}
                <Checkbox
                  checked={form.injury.lowerLimb.drowning}
                  onChange={handleInjuryCheckbox("lowerLimb", "drowning")}
                />
              </td>
              <td></td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>ត្រគាក</td>
              <td>
                <Checkbox
                  checked={form.injury.pelvis.wound}
                  onChange={handleInjuryCheckbox("pelvis", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.pelvis.bleeding}
                  onChange={handleInjuryCheckbox("pelvis", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.pelvis.fracture}
                  onChange={handleInjuryCheckbox("pelvis", "fracture")}
                />
              </td>
              <td colSpan={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>ផ្សេងៗ :</p>
                  <Input
                    className="input-field"
                    style={{ width: 300 }}
                    value={form.injury.other1}
                    onChange={handleInjuryOther("other1")}
                  />
                </div>
              </td>
            </tr>

            <tr style={{ textAlign: "center" }}>
              <td>ប្រដាប់បន្តពូជ</td>
              <td>
                <Checkbox
                  checked={form.injury.genital.wound}
                  onChange={handleInjuryCheckbox("genital", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.genital.bleeding}
                  onChange={handleInjuryCheckbox("genital", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.genital.fracture}
                  onChange={handleInjuryCheckbox("genital", "fracture")}
                />
              </td>
              <td colSpan={2}> </td>
            </tr>
            <tr style={{ textAlign: "center" }}>
              <td>ស្បែក</td>
              <td>
                <Checkbox
                  checked={form.injury.skin.wound}
                  onChange={handleInjuryCheckbox("skin", "wound")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.skin.bleeding}
                  onChange={handleInjuryCheckbox("skin", "bleeding")}
                />
              </td>
              <td>
                <Checkbox
                  checked={form.injury.skin.fracture}
                  onChange={handleInjuryCheckbox("skin", "fracture")}
                />
              </td>
              <td colSpan={2}> </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "start", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>ផ្សេងៗ :</p>
                  <Input
                    className="input-field"
                    style={{ width: 350 }}
                    value={form.injury.other2}
                    onChange={handleInjuryOther("other2")}
                  />
                </div>
              </td>
              <td colSpan={2}> </td>
            </tr>

            {/* រោគវិនិច្ឆ័យ និងការព្យាបាល Information Section */}
            <tr className="section-header">
              <td colSpan="6">រោគវិនិច្ឆ័យ និងការព្យាបាល</td>
            </tr>

            <tr>
              <td colSpan={2} style={{ width: 400 }}>
                ចង្វាក់ដង្ហើម{" "}
                <Input
                  className="input-field"
                  style={{ width: 100 }}
                  value={form.diagnosis.respiratoryRate}
                  onChange={handleDiagnosisField("respiratoryRate")}
                />{" "}
                /នាទី
              </td>
              <td colSpan={2} className="form-table-tr-hereder">
                ការសង្គ្រោះដែលបានធ្វើ
              </td>
              <td colSpan={2} className="form-table-tr-hereder">
                ថ្នាំនិងសម្ភារៈដែលបានប្រើប្រាស់
              </td>
            </tr>

            <tr>
              <td>
                អត់ដកដង្ហើម{" "}
                <Checkbox
                  checked={form.diagnosis.noBreath}
                  onChange={handleDiagnosisCheckbox("noBreath")}
                />
              </td>
              <td>
                ដកដង្ហក់{" "}
                <Checkbox
                  checked={form.diagnosis.breath}
                  onChange={handleDiagnosisCheckbox("breath")}
                />
              </td>
              <td>
                បូមស្លេស្ម{" "}
                <Checkbox
                  checked={form.diagnosis.suction}
                  onChange={handleDiagnosisCheckbox("suction")}
                />
              </td>
              <td style={{ width: 120 }}>
                ដាក់O2{" "}
                <Checkbox
                  checked={form.diagnosis.oxygen}
                  onChange={handleDiagnosisCheckbox("oxygen")}
                />
              </td>
              <td colSpan={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>1-</p>
                  <Input
                    className="input-field"
                    style={{ width: 300 }}
                    value={form.diagnosis.diagnosis1}
                    onChange={handleDiagnosisInput("diagnosis1")}
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td>
                ឡើងស្វាយ{" "}
                <Checkbox
                  checked={form.diagnosis.raiseSway}
                  onChange={handleDiagnosisCheckbox("raiseSway")}
                />
              </td>
              <td>
                ឡើងស្លេស្ម{" "}
                <Checkbox
                  checked={form.diagnosis.raiseSuction}
                  onChange={handleDiagnosisCheckbox("raiseSuction")}
                />
              </td>
              <td>
                អាងទុយបេ{" "}
                <Checkbox
                  checked={form.diagnosis.tube}
                  onChange={handleDiagnosisCheckbox("tube")}
                />
              </td>
              <td>
                លាងរបួស{" "}
                <Checkbox
                  checked={form.diagnosis.washWound}
                  onChange={handleDiagnosisCheckbox("washWound")}
                />
              </td>
              <td colSpan={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>2-</p>
                  <Input
                    className="input-field"
                    style={{ width: 300 }}
                    value={form.diagnosis.diagnosis2}
                    onChange={handleDiagnosisInput("diagnosis2")}
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                សម្ពាធឈាម{" "}
                <Input
                  className="input-field"
                  style={{ width: 70 }}
                  value={form.diagnosis.bloodPressure}
                  onChange={handleDiagnosisField("bloodPressure")}
                />{" "}
                / mmHg
              </td>
              <td>
                ធ្វើPCR{" "}
                <Checkbox
                  checked={form.diagnosis.pcr}
                  onChange={handleDiagnosisCheckbox("pcr")}
                />
              </td>
              <td>
                អបឆ្អឹកបាក់{" "}
                <Checkbox
                  checked={form.diagnosis.immobilize}
                  onChange={handleDiagnosisCheckbox("immobilize")}
                />
              </td>
              <td colSpan={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>3-</p>
                  <Input
                    className="input-field"
                    style={{ width: 300 }}
                    value={form.diagnosis.diagnosis3}
                    onChange={handleDiagnosisInput("diagnosis3")}
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                ជីបចរ{" "}
                <Input
                  className="input-field"
                  style={{ width: 70 }}
                  value={form.diagnosis.pulseRate}
                  onChange={handleDiagnosisField("pulseRate")}
                />{" "}
                /នាទី
              </td>
              <td>
                ឃាត់ឈាម{" "}
                <Checkbox
                  checked={form.diagnosis.stopBleed}
                  onChange={handleDiagnosisCheckbox("stopBleed")}
                />
              </td>
              <td>
                បញ្ជូលសេរ៉ូម{" "}
                <Checkbox
                  checked={form.diagnosis.serum}
                  onChange={handleDiagnosisCheckbox("serum")}
                />
              </td>
              <td colSpan={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>4-</p>
                  <Input
                    className="input-field"
                    style={{ width: 300 }}
                    value={form.diagnosis.diagnosis4}
                    onChange={handleDiagnosisInput("diagnosis4")}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                កម្រិតអុកស៊ីសែនក្នុងឈាម.{" "}
                <Input
                  className="input-field"
                  style={{ width: 50 }}
                  value={form.diagnosis.oxygenLevel}
                  onChange={handleDiagnosisField("oxygenLevel")}
                />{" "}
                / %
              </td>
              <td colSpan={2}> </td>
              <td colSpan={2}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // vertically center items
                    justifyContent: "center", // horizontally center the group
                    gap: "8px", // space between <p> and <Input>
                  }}
                >
                  <p style={{ margin: 0 }}>5-</p>
                  <Input
                    className="input-field"
                    style={{ width: 300 }}
                    value={form.diagnosis.diagnosis5}
                    onChange={handleDiagnosisInput("diagnosis5")}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                កម្រិតជាតិស្ករក្នុងឈាម{" "}
                <Input
                  className="input-field"
                  style={{ width: 50 }}
                  value={form.diagnosis.glucoseLevel}
                  onChange={handleDiagnosisField("glucoseLevel")}
                />{" "}
                /mg/dl
              </td>
              <td colSpan={2}> </td>
              <td colSpan={2}></td>
            </tr>

            {/* ហត្ថលេខា Information Section */}
            <tr className="section-header">
              <td colSpan="6">ហត្ថលេខា</td>
            </tr>
            <tr style={{ textAlign: "center", fontWeight: "bold" }}>
              <td colSpan={2}>
                ស្នាមមេដៃនិងឈ្មោះអ្នកជំងឺ
                <br />
                <br />
                <br />
                <br />
              </td>
              <td colSpan={2}>ហត្ថលេខានិងឈ្មោះអ្នកបញ្ជូនជំងឺ </td>
              <td colSpan={2}>ហត្ថលេខានិងឈ្មោះអ្នកបើកបររថយន្តសង្គ្រោះ</td>
            </tr>
            <tr>
              <td colSpan={6}>
                បរិយាយបន្ថែម{" "}
                <Input
                  className="input-field"
                  value={form.diagnosis.additionalDescription}
                  onChange={handleDiagnosisField("additionalDescription")}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={6} className="save-btn-row">
                <Button
                  danger
                  type="primary"
                  style={{ width: 150 }}
                  onClick={closeModel}
                  icon={<IoClose />}
                >
                  បោះបង់
                </Button>
                <Button
                  type="primary"
                  style={{ width: 150, marginLeft: 10 }}
                  onClick={handleSave}
                  icon={<BiSave />}
                >
                  {updateid ? "កែប្រែ" : "រក្សាទុក"}
                </Button>

                <Button
                  type="primary"
                  // hidden={!updateid}
                  className="buttonstylekhmer"
                  style={{ width: 150, marginLeft: 10 }}
                  onClick={handlePrint}
                  icon={<BsPrinterFill />}
                >
                  ព្រីនឯកសារ
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {loading && (
        <div className="sprinCustome">
          <GetLoading />
        </div>
      )}
    </>
  );
}
